module.exports = __webpack_public_path__ + "da8e43acda59d999aa0d2a948b7e0a00.svg";